import { useEffect, useState } from "react";

 
export default function IndependenceDayOfferModal({
  discount = "50",
  validTill = "2026-08-16",
  courseName = "all courses",
  ctaHref = "/courses",
  ctaLabel = "Enroll now",
  storageKey = "sl_independence_day_offer_dismissed",
  showDelayMs = 600,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const offerExpired = new Date() > new Date(`${validTill}T23:59:59`);
    // const alreadyDismissed =
    //   typeof window !== "undefined" &&
    //   window.localStorage.getItem(storageKey) === "true";

    if (offerExpired ) return;  //|| alreadyDismissed

    const timer = setTimeout(() => setVisible(true), showDelayMs);
    return () => clearTimeout(timer);
  }, [validTill, storageKey, showDelayMs]);

  useEffect(() => {
    if (!visible) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
     
  }, [visible]);

  function close() {
    setVisible(false);
    // if (typeof window !== "undefined") {
    //   window.localStorage.setItem(storageKey, "true");
    // }
  }

  if (!visible) return null;

  const validTillLabel = new Date(`${validTill}T00:00:00`).toLocaleDateString(
    "en-IN",
    { day: "numeric", month: "long" }
  );

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="id-offer-heading"
      onClick={close}
      style={styles.overlay}
    >
      <div onClick={(e) => e.stopPropagation()} style={styles.card}>
        <div style={{ ...styles.band, ...styles.bandTop }} />

        <button
          onClick={close}
          aria-label="Close offer popup"
          style={styles.closeButton}
        >
          ×
        </button>

        <div style={styles.content}>
          <div style={styles.flagRow}>
            <svg width="52" height="36" viewBox="0 0 52 36" aria-hidden="true">
              <rect x="0" y="0" width="52" height="12" fill="#FF9933" />
              <rect x="0" y="12" width="52" height="12" fill="#FFFFFF" />
              <rect x="0" y="24" width="52" height="12" fill="#138808" />
              <rect x="0" y="0" width="52" height="36" fill="none" stroke="#d1d5db" strokeWidth="1" />
              <circle cx="26" cy="18" r="6" fill="#FFFFFF" stroke="#152a5e" strokeWidth="1" />
              <circle cx="26" cy="18" r="1" fill="#152a5e" />
            </svg>
          </div>

          <h2 id="id-offer-heading" style={styles.heading}>
            Happy 80th Independence Day!
          </h2>

          <p style={styles.subheading}>
            Special offer on {courseName}
          </p>

          <div style={styles.badge}>
            <span style={styles.badgeLabel}>Limited time offer</span>
            <span style={styles.badgeDiscount}>{discount}% off</span>
          </div>

          <p style={styles.features}>
            Live classes · real-world projects · placement support
          </p>

          <a href={ctaHref} style={styles.cta}>
            {ctaLabel}
          </a>

          <p style={styles.footer} classname="text-sm text-black-500">
            Offer valid till {validTillLabel}
          </p>
        </div>

        <div style={{ ...styles.band, ...styles.bandBottom }} />
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 16,
  },
  card: {
    position: "relative",
    width: "100%",
    maxWidth: 380,
    background: "#ffffff",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
  },
  band: {
    height: 8,
    width: "100%",
  },
  bandTop: { background: "#FF9933" },
  bandBottom: { background: "#138808" },
  closeButton: {
    position: "absolute",
    top: 14,
    right: 14,
    width: 28,
    height: 28,
    borderRadius: "50%",
    border: "none",
    background: "#f3f4f6",
    color: "#374151",
    fontSize: 20,
    lineHeight: "28px",
    cursor: "pointer",
    zIndex: 1,
  },
  content: {
    padding: "28px 28px 24px",
    textAlign: "center",
  },
  flagRow: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 12,
  },
  heading: {
    margin: 0,
    fontSize: 21,
    fontWeight: 600,
    color: "#152a5e",
  },
  subheading: {
    margin: "6px 0 16px",
    fontSize: 15,
    fontWeight: 600,
    color: "#138808",
  },
  badge: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    background: "#152a5e",
    borderRadius: 10,
    padding: "14px 20px",
    marginBottom: 16,
  },
  badgeLabel: {
    fontSize: 12,
    letterSpacing: 1,
    color: "#ffffff",
    textTransform: "uppercase",
  },
  badgeDiscount: {
    fontSize: 30,
    fontWeight: 700,
    color: "#FF9933",
  },
  features: {
    margin: "0 0 20px",
    fontSize: 13,
    color: "#4b5563",
  },
  cta: {
    display: "inline-block",
    width: "100%",
    boxSizing: "border-box",
    background: "#138808",
    color: "#ffffff",
    fontSize: 16,
    fontWeight: 600,
    textDecoration: "none",
    padding: "12px 0",
    borderRadius: 27,
  },
  footer: {
    margin: "14px 0 0",
    fontSize: 12,
    //color: "#9ca3af",
  },
};
